import type { ChordController } from "~/keyboard/chordSequence";

import shouldSuppressForInputs from "~/keyboard/inputSuppression";
import isWedgeBurstInFlight, { isWedgeBurstCharacter } from "~/keyboard/wedgeBurst";

const createKeydownIgnorePredicate =
	(controller: ChordController) =>
	(event: KeyboardEvent): boolean => {
		if (isWedgeBurstInFlight() && isWedgeBurstCharacter(event)) {
			controller.reset();
			return true;
		}
		if (shouldSuppressForInputs(event)) {
			controller.reset();
			return false;
		}
		if (controller.handleKeydown(event)) {
			event.preventDefault();
			return true;
		}
		return false;
	};

export default createKeydownIgnorePredicate;
